import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
   redirect:'/login'   // 重定项
  },
 
  {
    path: '/login',     //登录页
    name: 'login',

    component: () => import('../views/login/index.vue')
  },
  {
    path: '/home',        //首页
    name: 'home',
    component: () => import('../views/home/index.vue'),

    children:[
      {
        path: '/index',       
        name: 'index',

        component: () => import('../views/home/index/index.vue'),

      },
      // {
      //   path: '/index',       
      //   name: 'index',
    
      //   component: () => import('../views/home/index/index.vue')
      // },
      {
        path: '/stats',       
        name: 'stats',
    
        component: () => import('../views/home/stats/index.vue'),

      },

      {
        path: '/wms',       
        name: 'wms',
    
        component: () => import('../views/home/wms/index.vue'),
        // children:[
        //   {
        //     path: '/wms/list',       
        //     name: 'wmslist',
        
        //     component: () => import('../views/home/wms/list.vue')
        //   },
        // ]
      },

      {
        path: '/user',       
        name: 'user',
    
        component: () => import('../views/home/user/index.vue'),
        // children:[
        //   {
        //     path: '/user/role',       
        //     name: 'userrole',
        
        //     component: () => import('../views/home/user/role.vue')
        //   },
        // ],
       
      },

       // 添加个人详情页路由
       {
        path: '/user/detail',
        name: 'userDetail',
        component: () => import('../views/home/user/detail.vue')
      },



       // 添加个人详情页路由
       {
        path: '/user/detail/particulars',
        name: 'userparticulars',
        component: () => import('../views/home/user/particulars.vue')
      },

  

      {
        path: '/department',       
        name: 'department',
    
        component: () => import('../views/home/department/index.vue'),

      },
      
      {
        path: '/quarters',       
        name: 'quarters',
    
        component: () => import('../views/home/quarters/index.vue'),

      },

      {
        path: '/parameter',       
        name: 'parameter',
    
        component: () => import('../views/home/parameter/index.vue'),

      },

      {
        path: '/monitor',       
        name: 'monitor',
    
        component: () => import('../views/home/monitor/index.vue'),

      },

      {
        path: '/tool',       
        name: 'tool',
    
        component: () => import('../views/home/tool/index.vue'),

      },

      {
        path: '/remote',       
        name: 'remote',
    
        component: () => import('../views/home/remote/index.vue'),

      },

      {
        path: '/remote/model',
        name: 'remoteModel',
        component: () => import('../views/home/remote/model.vue')
      },




      {
        path: '/anenst',       
        name: 'anenst',
    
        component: () => import('../views/home/anenst/index.vue'),

      },
      

      {
        path: '/vehicle',       
        name: 'vehicle',
    
        component: () => import('../views/home/vehicle/index.vue'),

      },
      {
        path: '/setup',       
        name: 'setup',
    
        component: () => import('../views/home/setup/index.vue'),

      }
     

    ]
  },
 
]

// 解决重复点击导航报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  mode: 'history', // 使用 HTML5 History 模式
  routes
})

export default router
